var _BlocksMigrationNamespace_instances, _BlocksMigrationNamespace_findChildPath, _BlocksMigrationNamespace_traverseTreeAsync, _BlocksMigrationNamespace_getContext;
import { __classPrivateFieldGet } from "tslib";
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { BlocksMigrationNamespaceContext } from './BlocksMigrationNamespaceContext';
export class BlocksMigrationNamespace extends PrivateAPINamespace {
    constructor() {
        super(...arguments);
        _BlocksMigrationNamespace_instances.add(this);
    }
    async removeElement(manifestContextId, selector) {
        const query = __classPrivateFieldGet(this, _BlocksMigrationNamespace_instances, "m", _BlocksMigrationNamespace_getContext).call(this, manifestContextId, selector).getQuery();
        await query.setStyles({
            cssProperties: {
                display: 'none',
            },
        });
    }
    async restoreElement(manifestContextId, selector) {
        const query = __classPrivateFieldGet(this, _BlocksMigrationNamespace_instances, "m", _BlocksMigrationNamespace_getContext).call(this, manifestContextId, selector).getQuery();
        await query.setStyles({
            cssProperties: {
                display: 'block',
            },
        });
    }
    async isRemoved(manifestContextId, selector) {
        const query = __classPrivateFieldGet(this, _BlocksMigrationNamespace_instances, "m", _BlocksMigrationNamespace_getContext).call(this, manifestContextId, selector).getQuery();
        const styles = await query.getStyles();
        return styles.cssProperties.display === 'none';
    }
    async listRemovedElements(manifestContextId) {
        const runtimeContext = this.ps.manifestsManager.getContextualRuntimeContext(manifestContextId);
        const removedElements = [];
        if (!runtimeContext?.tree) {
            return removedElements;
        }
        await __classPrivateFieldGet(this, _BlocksMigrationNamespace_instances, "m", _BlocksMigrationNamespace_traverseTreeAsync).call(this, runtimeContext.tree, async (node, path) => {
            const query = this.ps.manifestsManager.getContextualManifestQuery(manifestContextId, path);
            const styles = await query.getStyles();
            if (styles?.cssProperties?.display === 'none') {
                const selector = node.editorPointer?.innerElementPath?.at(-1);
                if (selector) {
                    removedElements.push(selector);
                }
            }
        });
        return removedElements;
    }
    getChildPath(manifestContextId, selector) {
        const runtimeContext = this.ps.manifestsManager.getContextualRuntimeContext(manifestContextId);
        if (!runtimeContext) {
            return [];
        }
        return __classPrivateFieldGet(this, _BlocksMigrationNamespace_instances, "m", _BlocksMigrationNamespace_findChildPath).call(this, runtimeContext.tree.children, selector);
    }
}
_BlocksMigrationNamespace_instances = new WeakSet(), _BlocksMigrationNamespace_findChildPath = function _BlocksMigrationNamespace_findChildPath(children, target, acc = []) {
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (child.editorPointer?.innerElementPath?.at(-1) === target) {
            return [...acc, i];
        }
        if (child.children?.length) {
            const result = __classPrivateFieldGet(this, _BlocksMigrationNamespace_instances, "m", _BlocksMigrationNamespace_findChildPath).call(this, child.children, target, [...acc, i]);
            if (result.length) {
                return result;
            }
        }
    }
    return [];
}, _BlocksMigrationNamespace_traverseTreeAsync = async function _BlocksMigrationNamespace_traverseTreeAsync(node, visitCb, path = []) {
    await visitCb(node, path);
    const children = node.children ?? [];
    children.forEach(async (child, index) => {
        await __classPrivateFieldGet(this, _BlocksMigrationNamespace_instances, "m", _BlocksMigrationNamespace_traverseTreeAsync).call(this, child, visitCb, [...path, index]);
    });
}, _BlocksMigrationNamespace_getContext = function _BlocksMigrationNamespace_getContext(manifestContextId, selector) {
    const childPath = this.getChildPath(manifestContextId, selector);
    return new BlocksMigrationNamespaceContext(this.ps, manifestContextId, childPath);
};
BlocksMigrationNamespace.namespace = 'blocksMigration';
//# sourceMappingURL=BlocksMigrationNamespace.js.map